module.exports = __webpack_public_path__ + "img/logo-more.b2ec57c6.png";